import { useEffect, useState } from 'react'
import { getAppFeatures } from '@utils/getAppFeatures'
import { logger } from '@utils/logger'

export const useDinamycStyles = (): { loading: boolean } => {
  const hrefs = getAppFeatures()?.styles
  const [filesLoaded, setFilesLoaded] = useState<number>(0)
  const [loading, setLoaded] = useState(false)

  useEffect(() => {
    if (!hrefs) return

    hrefs?.forEach((url) => {
      const existing = document.querySelector(`[href='${url}']`)

      if (!existing) {
        const link = document.createElement('link')
        link.rel = 'stylesheet'
        link.href = url
        link.type = 'text/css'
        link.media = 'all'
        link.onload = () => {
          setFilesLoaded((n) => n + 1)
        }
        document.head.appendChild(link)
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (filesLoaded === hrefs?.length) {
      logger('[useDinamycStyles] - All files loaded')
      setLoaded(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filesLoaded])

  return {
    loading: loading,
  }
}
